import { tv } from 'tailwind-variants'

export const inputStyles = tv({
	base: 'font-primary',
	slots: {
		container: 'w-full bg-transparent',
		input:
			'outline-none border border-palette_3 bg-white text-palette_6 font-primary-light web:text-base text-[0.86em] w-full rounded-[0.3em] px-[1.1em] py-3 box-border placeholder:text-inactive_1 placeholder:opacity-100',
		placeholder: 'font-primary',
	},
	variants: {
		editable: {
			false: {
				input: 'opacity-50 web:cursor-not-allowed',
			},
		},
	},
})
